import { WebSocketAction } from 'constants/web-socket-action';
import { getServer } from 'helpers/get-server';
import { type LogoutEvent } from 'interfaces/web-socket-events';

import { sendEvent } from './send-event';

/**
 * @see https://platform.text.com/docs/messaging/agent-chat-api/rtm-reference#logout
 */
export async function logout(): Promise<unknown> {
  const event: LogoutEvent = {
    action: WebSocketAction.Logout,
    payload: {},
    version: '3.5',
  };

  return await sendEvent<unknown>(getServer(), event);
}
